import * as React from 'react';
import * as Recaptcha from 'react-recaptcha';
import {Loader} from '../loader/loader';
import {RECAPTCHA_KEY} from '../../utils/config';
import './styles.sass';

const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';

export interface ICaptchaProps {
  isVisible?: boolean;
  className?: string;
  verifyCallback?: () => any;
}
interface ICaptchaState {
  loading: boolean;
}

class Captcha extends React.Component<ICaptchaProps, ICaptchaState> {
  private static captchaLoaded: boolean = false;

  public state = {
    loading: true,
  };

  public componentDidMount(): void {
    if (Captcha.captchaLoaded) {return;}
    Captcha.captchaLoaded = true;

    const script = document.createElement('script');
    script.src = RECAPTCHA_URL;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
  }

  public render(): React.ReactElement<{}> {
    if (!this.props.isVisible) {return null;}
    return (
      <div className={`captcha-container ${this.props.className}`}>
        {this.state.loading && <Loader />}

        <Recaptcha
          sitekey={RECAPTCHA_KEY}
          render={'explicit'}
          onloadCallback={() => this.captchaLoaded()}
          verifyCallback={this.props.verifyCallback}
        />
      </div>
    );
  }

  private captchaLoaded(): void {
    this.setState({
      loading: false,
    });
  }
}

export default Captcha;
